import { c as _c } from "react/compiler-runtime";
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import type { TooltipProps } from '@onefootprint/ui';
import { Tooltip } from '@onefootprint/ui';
import React, { type JSX } from 'react';
import usePermissions from '@/hooks/use-permissions';
export type PermissionGateProps = {
  children: JSX.Element;
  scopeKind: Exclude<TenantScope, 'decrypt_all'>['kind'];
  fallbackText: string;
  tooltipSide?: TooltipProps['side'];
};
const PermissionGate = t0 => {
  const $ = _c(6);
  const {
    children,
    scopeKind,
    fallbackText,
    tooltipSide: t1
  } = t0;
  const tooltipSide = t1 === undefined ? "top" : t1;
  const {
    hasPermission
  } = usePermissions();
  let t2;
  if ($[0] !== children || $[1] !== fallbackText || $[2] !== hasPermission || $[3] !== scopeKind || $[4] !== tooltipSide) {
    t2 = hasPermission(scopeKind) ? children : <Tooltip disabled={!fallbackText} content={fallbackText} side={tooltipSide}>{React.cloneElement(children, {
        disabled: true
      })}</Tooltip>;
    $[0] = children;
    $[1] = fallbackText;
    $[2] = hasPermission;
    $[3] = scopeKind;
    $[4] = tooltipSide;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default PermissionGate;